import { render, staticRenderFns } from "./DC_GR_1F.vue?vue&type=template&id=342f869c&scoped=true"
import script from "./DC_GR_1F.vue?vue&type=script&lang=js"
export * from "./DC_GR_1F.vue?vue&type=script&lang=js"
import style0 from "./DC_GR_1F.vue?vue&type=style&index=0&id=342f869c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f869c",
  null
  
)

export default component.exports